import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Truck = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M20 8.45117H17V4.45117H3C1.9 4.45117 1 5.35117 1 6.45117V17.4512H3C3 19.1112 4.34 20.4512 6 20.4512C7.66 20.4512 9 19.1112 9 17.4512H15C15 19.1112 16.34 20.4512 18 20.4512C19.66 20.4512 21 19.1112 21 17.4512H23V12.4512L20 8.45117ZM6 18.9512C5.17 18.9512 4.5 18.2812 4.5 17.4512C4.5 16.6212 5.17 15.9512 6 15.9512C6.83 15.9512 7.5 16.6212 7.5 17.4512C7.5 18.2812 6.83 18.9512 6 18.9512ZM19.5 9.95117L21.46 12.4512H17V9.95117H19.5ZM18 18.9512C17.17 18.9512 16.5 18.2812 16.5 17.4512C16.5 16.6212 17.17 15.9512 18 15.9512C18.83 15.9512 19.5 16.6212 19.5 17.4512C19.5 18.2812 18.83 18.9512 18 18.9512Z"
    />
  </svg>
);
